"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_dateformat_1 = __importDefault(require("intl-dateformat"));
const ensureDate_1 = __importDefault(require("../ensureDate"));
const PREDEFINED_FORMATS = {
    dateString: 'YYYY-MM-DD',
    default: 'MMMM DD, YYYY',
    exhaustive: 'YYYY-MM-DD HH:mm:ss',
    iso: 'YYYY-MM-DDTHH:mm:ssZ',
    short: 'MMM DD, YYYY',
};
const formatDateTime = (dateTime, format, timeZone) => {
    const parsedDate = ensureDate_1.default(dateTime);
    if (format === 'iso')
        return parsedDate.toISOString();
    try {
        return intl_dateformat_1.default(parsedDate, PREDEFINED_FORMATS[format] || format, timeZone ? { timezone: timeZone } : undefined);
    }
    catch (err) {
        // `intl-dateformat` uses `Intl.DateTimeFormat` under the hood.
        // In order to still support legacy browsers, we fallback on `Date#toLocalDateString`.
        try {
            return parsedDate.toLocaleDateString('en-US', timeZone ? { timeZone } : undefined);
        }
        catch (err2) {
            // In some edge-cases the backend can send non-IANA timezones.
            // If so we can still try to format the date correctly with no timezone.
            return formatDateTime(dateTime, format);
        }
    }
};
exports.default = formatDateTime;
